module.exports = __webpack_public_path__ + "img/emailB.ba59e848.png";